import { t } from 'i18next';
import { observer } from 'mobx-react';
import numeral from 'numeral';

import { useMeasurement } from '@/hooks/useMeasurement';
import {
  getSliderPoints,
  useMinSetpointValue,
  useMaxSetpointValue,
  useGetCompressorSliderPoints,
} from '@/comp/MapBuilder/nodes/compressor/CompressorNodeWidget.utils';
import { DeviceType } from '@/constants/deviceTypeEnum';
import { CompressorActivityStateEnum } from '@/constants/enums';
import { useStores } from '@/hooks/use-stores';
import { Entity } from '@/comp/MapBuilder/nodes/nodeWidget/NodeWidget.types';

import Slider from '../Slider/Slider';

const CompressorSliders = observer(({ entity }: { entity: Entity }) => {
  const { tvalue, tunit } = useMeasurement();
  const { stationStore } = useStores();
  const { deviceType, connectivity, pressureBar, activity, inletValveOpening, bypassValveOpening } = entity;
  const sliderPoints = getSliderPoints(t);

  return (
    <>
      <div className="main-slider">
        <Slider
          showTierLock
          title={t('Pressure')}
          value={tvalue(Number(pressureBar?.toFixed(2)), 'bar')}
          unit={t(tunit('Bar'))}
          min={useMinSetpointValue(entity)}
          max={useMaxSetpointValue(entity)}
          points={useGetCompressorSliderPoints(entity, stationStore.hasNewActionsFeature)}
          connectivity={connectivity}
          highlightSlider={activity?.toLowerCase() === CompressorActivityStateEnum.Load}
          addSideGaps
          hasTarget
        />
      </div>
      {[DeviceType.Centrifugal, DeviceType.CentrifugalAndPowerSensor].includes(deviceType as DeviceType) && (
        <div className="centrifugal-sliders">
          <div className="centrifugal-slider-wrapper">
            <Slider
              title={t('inletValve')}
              points={sliderPoints}
              value={numeral(inletValveOpening).format(0)}
              min={0}
              max={100}
              unit={'%'}
              connectivity={entity.connectivity}
              highlightSlider={entity.activity?.toLowerCase() === CompressorActivityStateEnum.Load}
            />
          </div>
          <div className="centrifugal-slider-wrapper">
            <Slider
              title={t('bypassValve')}
              points={sliderPoints}
              value={numeral(bypassValveOpening).format(0)}
              min={0}
              max={100}
              unit={'%'}
              connectivity={entity.connectivity}
              highlightSlider={entity.activity?.toLowerCase() === CompressorActivityStateEnum.Load}
            />
          </div>
        </div>
      )}
    </>
  );
});

export default CompressorSliders;
